export let getClientPhoneNumbers = async (profileId, setClientPhoneNumbers, API_URL, authTokens) => {
    if (profileId === 'new') return
  
    let response = await fetch(`${API_URL}/client/profile/phone/${profileId}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + authTokens?.access
      }
    })
    let data = await response.json()
    
    setClientPhoneNumbers(data)
  }